import React from 'react';
import cx from 'classnames';
import {Button, Text, Title} from '@priority-software/priority-style-react/dist';
import texts from '../../texts';
import styles from './styles.module.scss';
import img from './../../../../images/SchoolManagement.jpg';

type Props = {
    onStartOnBoarding: () => void;
    onPauseOnBoarding: () => void;
    onMessageShow: () => void;
};

export const WelcomeContent = ({onStartOnBoarding, onPauseOnBoarding, onMessageShow}: Props) => {
    return (
        <div className={styles.component}>
            <Title skin="h1" textColor="primary-500" componentClasses={styles.title}>
                {texts.welcome_title}
            </Title>

            <Text tag="p" textColor="primary-700" skin="paragraph-1" fontWeight="normal">
                {texts.welcome_text}
            </Text>

            <img width={660} height={393} src={img} alt="" className={styles.welcomeImg} />

            <footer className={styles.footer}>
                <Button skin="text" onClick={onMessageShow}>
                    {texts.welcome_skip_label}
                </Button>

                <div className={styles.btnGroup}>
                    <Button
                        componentClasses={cx(styles.btn, styles.textCenter)}
                        size="medium"
                        onClick={onPauseOnBoarding}
                        skin="secondary"
                    >
                        {texts.welcome_action_secondary}
                    </Button>

                    <Button
                        componentClasses={cx(styles.btn, styles.textCenter)}
                        size="medium"
                        onClick={onStartOnBoarding}
                        skin="primary"
                    >
                        {texts.welcome_action_primary}
                    </Button>
                </div>
            </footer>
        </div>
    );
};
